import ClumseChat from "../ClumseChat";

/**
 * Public marketing / screenshot sandbox — no auth required.
 * Debug controls render only when `isMarketingDebugControlsEnabled()` is true.
 */
export default function MarketingSandboxPage() {
  return <ClumseChat />;
}
